const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "25.5px",
    viewBox: "0 0 28 25.5",
    style: {
      enableBackground: "new 0 0 28 25.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M24.1,25.5H3.9c-2.2,0-3.9-1.8-3.9-3.9V3.9C0,1.8,1.8,0,3.9,0h5.6c0.9,0,1.7,0.4,2.2,1.2l1.7,2.6h10.6 c2.2,0,3.9,1.8,3.9,3.9v13.8C28,23.7,26.2,25.5,24.1,25.5z M3.9,2.8c-0.6,0-1.1,0.5-1.1,1.1v17.6c0,0.6,0.5,1.1,1.1,1.1h20.1 c0.6,0,1.1-0.5,1.1-1.1V7.7c0-0.6-0.5-1.1-1.1-1.1H12.7c-0.5,0-0.9-0.2-1.2-0.6L9.5,2.8H3.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.5ec2aa137ec3eff35b5d1605a3f11e2a.svg";
export { ForwardRef as ReactComponent };